const PrivacyPolicy = ()=>{
return (
  
        <main>
          <section className="banner customrPageSec">
            <div className="container">
              <div className="Pledge-inner">
                <div className="pledge-inner-box customrPageSecHeader">
                  {/*
                          <div class="Pledge-inner-img">
                              <img src="images/pledge/pledge-logo.png" class="img-fluid" alt="">
                          </div>
                          */}
                  <h1 className>VECTRA International</h1>
                  <h4 className>VECTRA International Shop - Privacy Policy</h4>
                </div>
                <div className="pledge-inner-content customrPageContent">
                  <p className="mb-1">VECTRA International ("VECTRA") is committed to protecting your privacy.</p>
                  <p>This Privacy Policy explains how VECTRA collects, uses, discloses, and safeguards your personal information. One of our goals is to protect the users of this site from abuses of privacy. By accessing or using VECTRA’s web page or Shop, you agree to the practices described in this Privacy Policy.
                  </p>
                  <ul className="pl-20">
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">1. Information We Collect</h4>
                      <p className="text">VECTRA may collect the following types of information:</p>
                      <ul className>
                        <li className="mb-4" style={{listStyleType: 'none'}}>
                          <h4 className="fw-600 mb-2">1.1. Personal Information:</h4>
                          <p className="text">When you purchase or create an account on VECTRA’s e-commerce shop, VECTRA may collect personal information such as your name, phone number, email address, billing address, and payment information. We do not sell, rent, lease, or borrow our users’ information.</p>
                        </li>
                        <li className="mb-4" style={{listStyleType: 'none'}}>
                          <h4 className="fw-600 mb-2">1.2. IP address information:</h4>
                          <p className="text">Our web server logs specific information about the usage of this website. This information is not shared and is used for statistical purposes only.</p>
                        </li>
                        <li className="mb-4" style={{listStyleType: 'none'}}>
                          <h4 className="fw-600 mb-2">1.3. Usage Information:</h4>
                          <p className="text">VECTRA may collect information about your interactions with VECTRA’s website, including the pages visited, links clicked, and the duration of your visits.</p>
                        </li>
                        <li className="mb-4" style={{listStyleType: 'none'}}>
                          <h4 className="fw-600 mb-2">1.4. Device and Browser Information:</h4>
                          <p className="text">VECTRA may collect information about the device and browser you use to access VECTRA’s website, including your IP address, operating system, and browser type.</p>
                        </li>
                      </ul>
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">2. How VECTRA Uses Your Information</h4>
                      <p className="text">VECTRA uses the information VECTRA collects for the following purposes:</p>
                      <ul className>
                        <li className="mb-4" style={{listStyleType: 'none'}}>
                          <h4 className="fw-600 mb-2">2.1. Order Processing:</h4>
                          <p className="text">VECTRA uses your personal information to process and fulfill your orders and to provide access to your purchased products and/or services.</p>
                        </li>
                        <li className="mb-4" style={{listStyleType: 'none'}}>
                          <h4 className="fw-600 mb-2">2.2. Customer Support:</h4>
                          <p className="text">VECTRA uses your information to provide customer support and respond to your inquiries or requests.</p>
                        </li>
                        <li className="mb-4" style={{listStyleType: 'none'}}>
                          <h4 className="fw-600 mb-2">2.3. Analytics:</h4>
                          <p className="text">VECTRA uses usage information for analytics to improve the content and user experience of VECTRA’s e-commerce shop.</p>
                        </li>
                        <li className="mb-4" style={{listStyleType: 'none'}}>
                          <h4 className="fw-600 mb-2">2.4. Legal Compliance:</h4>
                          <p className="text">VECTRA may use your information as necessary to comply with applicable laws, regulations, and legal processes.</p>
                        </li>
                      </ul>
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">3. Information Sharing</h4>
                      <p className="text">VECTRA does not sell or rent your personal information to third parties. VECTRA may share your information with the following:</p>
                      <ul className>
                        <li className="mb-4" style={{listStyleType: 'none'}}>
                          <h4 className="fw-600 mb-2">Service Providers:</h4>
                          <p className="text">VECTRA may share your information with providers or contractors who help VECTRA with payment processing, order fulfillment, and website hosting.</p>
                        </li>
                        <li className="mb-4" style={{listStyleType: 'none'}}>
                          <h4 className="fw-600 mb-2">3.2. Legal Requirements:</h4>
                          <p className="text">VECTRA may disclose your information if required by law or if VECTRA believes such action is necessary to comply with legal requirements.</p>
                        </li>
                      </ul>
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">4. Cookies and Tracking Technologies</h4>
                      <p className="text">VECTRA’s e-commerce shop may use cookies and similar tracking technologies to enhance your experience. You can adjust your browser settings to disable cookies, which may affect your ability to use VECTRA’s website.</p>	  
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">5. Security</h4>
                      <p className="text">VECTRA takes reasonable measures to protect your information. However, no method of online transmission or storage is 100% secure. While VECTRA strives to protect your personal information, VECTRA cannot guarantee its security.</p>	  
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">6. Your Privacy Choices</h4>
                      <p className="text">You may have various privacy choices, including:</p>
                      <ul className>
                        <li className="mb-4" style={{listStyleType: 'none'}}>
                          <h4 className="fw-600 mb-2">6.1. Access and Correction:</h4>
                          <p className="text">You have the right to access and correct your personal information. Contact VECTRA to request access or corrections.</p>
                        </li>
                        <li className="mb-4" style={{listStyleType: 'none'}}>
                          <h4 className="fw-600 mb-2">6.2. Marketing Communications:</h4>
                          <p className="text">You may choose not to receive marketing communications from VECTRA by following the unsubscribe instructions.</p>
                        </li>
                      </ul>
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">7. External links</h4>
                      <p className="text">Our site contains links to other sites. VECTRA International is not responsible for such websites’ privacy practices or content.</p>	  
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">8. Contact Information</h4>
                      <p className="text">For questions or concerns regarding this Privacy Policy or your personal information, please get in touch with VECTRA at info@vectra-intl.com.
                      </p>	  
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </main>
      );
    };
 export default PrivacyPolicy;   